import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import Location  from "./components/Location";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import Footer from "./components/Footer";
import Amenities from "./components/Amenities";
import Master from "./components/Master";
import Construct from "./components/Construct";
import Project from "./components/Project";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Construct />
      <Amenities />
      <Project />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Location />
      <Master />
      <Footer />
    </div>
  );
};

export default App;
